import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import {
  getUserProjects,
  ProjectWithMemberCount,
} from '@/features/projects/shared/api/get-user-projects';

export const getUserProjectsQueryKey = () => ['user-projects'];

type Props = Omit<
  UseQueryOptions<ProjectWithMemberCount[], unknown, ProjectWithMemberCount[]>,
  'queryKey' | 'queryFn'
>;

export const useUserProjects = (props?: Props) =>
  useQuery({
    ...props,
    queryKey: getUserProjectsQueryKey(),
    queryFn: getUserProjects,
  });
